import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from "redux-thunk";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from './userReducer';
import orgReducer from './organization/orgReducer';
import leadsReducer from './kaiziqLeads/kaiziqLeadsReducer';
import tokenReducer from './token/tokenReducer';
import projectReducer from './project/projectReducer';
import activeUserReducer from './activeUser/activeUserReducer';
import fileStorageReducer from './fileStorage/fileStorageReducer';
import whatsappTemplateFileReducer from './whatsappTemplateFile/whatsappTemplateFileReducer';
import cacheReducer from './cacheReducer';

const combine = combineReducers({
  user: userReducer,
  org: orgReducer,
  leads: leadsReducer,
  project: projectReducer,
  activeUser: activeUserReducer,
  fileStorage: fileStorageReducer,
  templateFiles: whatsappTemplateFileReducer,
  token: tokenReducer,
  cache: cacheReducer
});

const persistConfig = {
  key: 'root',
  storage,
};

const rootReducer = (state, action)=> {
    if(action.type === 'RESET') {
        return combine(undefined, action);
    }
    return combine(state, action);
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

export { store, persistor };